import React from 'react';
import { Button } from './ui/button';
import {
  ClipboardList, RefreshCw, Package, ArrowLeftRight, BarChart3,
  TrendingUp, TrendingDown, Star, FileText, MessageSquare, Trophy,
  Megaphone, Smartphone, User, Database, Users, Clock,
  AlertTriangle, Calendar, Shield, Heart, Target, Handshake, Layers,
  CheckCircle, ShieldAlert, Sparkles, Settings, QrCode
} from 'lucide-react';

const AdminSubTabs = ({
  activeTab,
  user,
  // Jogos
  activeJogosSubTab, setActiveJogosSubTab,
  // Colaboradores
  activeColaboradoresSubTab, setActiveColaboradoresSubTab,
  // Monitorizacao (inclui Analise)
  activeMonitorizacaoSubTab, setActiveMonitorizacaoSubTab,
  // Produtos
  activeProdutosSubTab, setActiveProdutosSubTab,
  // Clientes
  activeClientesSubTab, setActiveClientesSubTab,
  // Fidelizacao
  activeFidelizacaoSubTab, setActiveFidelizacaoSubTab,
  // Comercial
  activeComercialSubTab, setActiveComercialSubTab,
  // 🆕 22-05-2026 — setActiveTab para atalho "Parcerias" em Fidelização (link cruzado).
  setActiveTab,
  // Controlo
  activeControloSubTab, setActiveControloSubTab,
  // Sistema
  activeSistemaSubTab, setActiveSistemaSubTab,
  // Vendas
  activeVendasSubTab, setActiveVendasSubTab,
  // Horario
  activeHorarioSubTab, setActiveHorarioSubTab,
  // Extras
  alertasParceriasCount,
  fidBadges = { hoje: 0, clientes: 0, config: 0 },
}) => {
  return (
    <>
      {/* Sub-navegacao para Vendas */}
      {activeTab === 'vendas' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              <Button variant={activeVendasSubTab === 'registo' ? 'default' : 'ghost'} onClick={() => setActiveVendasSubTab('registo')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="vendas-subtab-registo">
                <ClipboardList className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Vendas (XD)
              </Button>
              {user.role === 'admin' && (
                <Button variant={activeVendasSubTab === 'exploracao' ? 'default' : 'ghost'} onClick={() => setActiveVendasSubTab('exploracao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="vendas-subtab-exploracao">
                  <BarChart3 className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Exploracao
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeVendasSubTab === 'colaboradores' ? 'default' : 'ghost'} onClick={() => setActiveVendasSubTab('colaboradores')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="vendas-subtab-colaboradores">
                  <Users className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Por Colaborador
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Operacao agora renderiza ConsultaOperacional diretamente, sem sub-tabs */}
      {/* Sub-navegacao para Jogos */}
      {activeTab === 'jogos' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              <Button variant={activeJogosSubTab === 'fechos-turnos' ? 'default' : 'ghost'} onClick={() => setActiveJogosSubTab('fechos-turnos')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2">
                <ClipboardList className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Fecho de Jogos
              </Button>
              <Button variant={activeJogosSubTab === 'revendas' ? 'default' : 'ghost'} onClick={() => setActiveJogosSubTab('revendas')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2">
                <RefreshCw className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Revenda Raspadinhas
              </Button>
              <Button variant={activeJogosSubTab === 'stocks' ? 'default' : 'ghost'} onClick={() => setActiveJogosSubTab('stocks')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2">
                <Package className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Stocks
              </Button>
              <Button variant={activeJogosSubTab === 'transferencias' ? 'default' : 'ghost'} onClick={() => setActiveJogosSubTab('transferencias')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2">
                <ArrowLeftRight className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Transferencias
              </Button>
              <Button variant={activeJogosSubTab === 'resumo' ? 'default' : 'ghost'} onClick={() => setActiveJogosSubTab('resumo')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2">
                <BarChart3 className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Resumo Diario
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Colaboradores */}
      {activeTab === 'colaboradores' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              {user.role === 'admin' && (
                <Button variant={activeColaboradoresSubTab === 'gestao' ? 'default' : 'ghost'} onClick={() => setActiveColaboradoresSubTab('gestao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="colaboradores-subtab-gestao">
                  <Users className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Gestao
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Monitorizacao (inclui Analise absorvida) */}
      {activeTab === 'monitorizacao' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              {user.role === 'admin' && (
                <Button variant={activeMonitorizacaoSubTab === 'monitorizacao' ? 'default' : 'ghost'} onClick={() => setActiveMonitorizacaoSubTab('monitorizacao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="monitorizacao-subtab-monitorizacao">
                  <BarChart3 className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Monitorizacao
                </Button>
              )}
              <Button variant={activeMonitorizacaoSubTab === 'comparacoes' ? 'default' : 'ghost'} onClick={() => setActiveMonitorizacaoSubTab('comparacoes')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="monitorizacao-subtab-comparacoes">
                <TrendingUp className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Comparacoes
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Produtos — Parte 2: Ação primeiro, técnica depois.
          Ordem: Hoje/Decisões → Stock & Ruturas → Validades → Quebras → Catálogo → Análise */}
      {activeTab === 'produtos' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              {/* Sub-tab "Hoje" (decisoes) escondida do menu por proposta UX 3 blocos
                  (duplicava Operacional Hoje). Deep-link continua funcional via
                  ?tab=produtos&subTab=decisoes durante 1-2 sprints antes de remover. */}
              {(user.role === 'admin' || user.role === 'responsavel') && (
                <Button variant={activeProdutosSubTab === 'stock' ? 'default' : 'ghost'} onClick={() => setActiveProdutosSubTab('stock')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="produtos-subtab-stock">
                  <Target className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Stock & Ruturas
                </Button>
              )}
              <Button variant={activeProdutosSubTab === 'validades' ? 'default' : 'ghost'} onClick={() => setActiveProdutosSubTab('validades')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="produtos-subtab-validades">
                <Calendar className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Validades
              </Button>
              {(user.role === 'admin' || user.role === 'responsavel') && (
                <Button variant={activeProdutosSubTab === 'quebras' ? 'default' : 'ghost'} onClick={() => setActiveProdutosSubTab('quebras')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="produtos-subtab-quebras">
                  <AlertTriangle className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Quebras
                </Button>
              )}
              <Button variant={activeProdutosSubTab === 'catalogo' ? 'default' : 'ghost'} onClick={() => setActiveProdutosSubTab('catalogo')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="produtos-subtab-catalogo">
                <Package className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Catálogo
              </Button>
              {(user.role === 'admin' || user.role === 'responsavel') && (
                <Button variant={activeProdutosSubTab === 'analise' ? 'default' : 'ghost'} onClick={() => setActiveProdutosSubTab('analise')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="produtos-subtab-analise">
                  <BarChart3 className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Análise
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Clientes — Versão A: Gestão / Higiene de Dados / Análise (RFM) */}
      {activeTab === 'clientes' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              <Button variant={activeClientesSubTab === 'gestao' ? 'default' : 'ghost'} onClick={() => setActiveClientesSubTab('gestao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="clientes-subtab-gestao">
                <Users className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Gestão
              </Button>
              {(user.role === 'admin' || user.role === 'responsavel') && (
                <Button variant={activeClientesSubTab === 'higiene' ? 'default' : 'ghost'} onClick={() => setActiveClientesSubTab('higiene')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="clientes-subtab-higiene">
                  <Shield className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Higiene de Dados
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeClientesSubTab === 'rfm' ? 'default' : 'ghost'} onClick={() => setActiveClientesSubTab('rfm')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="clientes-subtab-rfm">
                  <BarChart3 className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Análise (RFM)
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Fidelizacao (SIMPLIFICAÇÃO 22-05-2026 — 6 abas operacionais).
          Ordem: 1. Visão Geral · 2. Clientes & Adesões · 3. Pontos, Cashback & Vales
                 4. Campanhas & Comunicação · 5. Parcerias · 6. Configuração
          Escondidos do nível principal (mantêm-se acessíveis por deep-link via
          redirect em AdminDashboard.jsx): em-vigor, ciclo, analise.
          NOTA: o tab pai 'fidelizacao' é admin-only (AdminNavigationTabs.jsx:192). */}
      {activeTab === 'fidelizacao' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              {/* 1. Visão Geral (era "Hoje") — id interno preservado */}
              <Button variant={activeFidelizacaoSubTab === 'hoje' ? 'default' : 'ghost'} onClick={() => setActiveFidelizacaoSubTab('hoje')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="subtab-visao-geral">
                <CheckCircle className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Visão Geral
                {fidBadges.hoje > 0 && (
                  <span className="ml-1 bg-red-500 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] flex items-center justify-center px-1" data-testid="badge-hoje">
                    {fidBadges.hoje > 99 ? '99+' : fidBadges.hoje}
                  </span>
                )}
              </Button>
              {/* 2. Clientes & Adesões (badge: adesões pendentes) */}
              <Button variant={activeFidelizacaoSubTab === 'clientes' ? 'default' : 'ghost'} onClick={() => setActiveFidelizacaoSubTab('clientes')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="subtab-clientes">
                <Users className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Clientes & Adesões
                {fidBadges.clientes > 0 && (
                  <span className="ml-1 bg-blue-500 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] flex items-center justify-center px-1" data-testid="badge-clientes">
                    {fidBadges.clientes > 99 ? '99+' : fidBadges.clientes}
                  </span>
                )}
              </Button>
              {/* 3. Pontos, Cashback & Vales (era "Pontos & Vales") */}
              <Button variant={activeFidelizacaoSubTab === 'pontos' ? 'default' : 'ghost'} onClick={() => setActiveFidelizacaoSubTab('pontos')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="subtab-pontos">
                <Star className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Pontos, Cashback & Vales
              </Button>
              {/* 4. Campanhas & Comunicação */}
              <Button variant={activeFidelizacaoSubTab === 'comunicacao' ? 'default' : 'ghost'} onClick={() => setActiveFidelizacaoSubTab('comunicacao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="subtab-comunicacao">
                <Megaphone className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Campanhas & Comunicação
              </Button>
              {/* 5. Parcerias — atalho read-only para Comercial > Parcerias (cross-module).
                  Faz setActiveTab('comercial') + setActiveComercialSubTab('parcerias').
                  NÃO duplica conteúdo, apenas navega. */}
              <Button variant="ghost" onClick={() => { if (setActiveTab) setActiveTab('comercial'); setActiveComercialSubTab('parcerias'); }} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 text-muted-foreground hover:text-foreground" data-testid="subtab-parcerias-shortcut" title="Ir para Comercial > Parcerias">
                <Handshake className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Parcerias
                <span className="ml-1 text-[9px] opacity-60">↗</span>
              </Button>
              {/* 6. Configuração (era "Reconciliação") — admin-only.
                  Sempre visível agora (não mais condicional a pendências), porque
                  alberga as configurações de RGPD, regras, dados, etc. */}
              {user?.role === 'admin' && (
                <Button variant={(activeFidelizacaoSubTab === 'reconciliacao' || activeFidelizacaoSubTab === 'config') ? 'default' : 'ghost'} onClick={() => setActiveFidelizacaoSubTab('reconciliacao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="subtab-configuracao">
                  <Settings className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Configuração
                  {fidBadges.config > 0 && (
                    <span className="ml-1 bg-amber-500 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] flex items-center justify-center px-1" data-testid="badge-configuracao">
                      {fidBadges.config > 99 ? '99+' : fidBadges.config}
                    </span>
                  )}
                </Button>
              )}
              {/* ── HIDDEN do nível principal (acessíveis por deep-link/redirect) ──
                  - subtab-em-vigor (era visível) → conteúdo em "Em Vigor" continua em
                    Campanhas & Comunicação. Bookmarks ?subTab=em-vigor redirecionam.
                  - subtab-ciclo → conteúdo "Ciclo & Bónus" continua acessível por id
                    interno; bookmarks redirecionam para Pontos.
                  - subtab-analise → conteúdo continua acessível em Clientes & Adesões;
                    bookmarks redirecionam.
                  - subtab-app-cliente → tab principal autónoma (refactor anterior).
              */}
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Comercial */}
      {activeTab === 'comercial' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              <Button variant={activeComercialSubTab === 'parcerias' ? 'default' : 'ghost'} onClick={() => setActiveComercialSubTab('parcerias')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="comercial-subtab-parcerias">
                <Handshake className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Parcerias
              </Button>
              {/* "Campanhas" foi movido para Fidelização → Campanhas & Comunicação (eliminar duplicação).
                  Bookmarks antigos continuam a funcionar via routing em AdminDashboard. */}
              {user.role === 'admin' && (
                <Button variant={activeComercialSubTab === 'motor' ? 'default' : 'ghost'} onClick={() => setActiveComercialSubTab('motor')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="comercial-subtab-motor">
                  <Target className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Margens &amp; Custos
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Operacional Hoje (chave interna mantida: 'controlo') */}
      {activeTab === 'controlo' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              {(user.role === 'admin' || user.role === 'responsavel') && (
                <Button variant={activeControloSubTab === 'hoje' ? 'default' : 'ghost'} onClick={() => setActiveControloSubTab('hoje')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="controlo-subtab-hoje">
                  <Sparkles className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Hoje
                </Button>
              )}
              {(user.role === 'admin' || user.role === 'responsavel') && (
                <Button variant={(activeControloSubTab === 'alertas' || activeControloSubTab === 'alertas-op' || activeControloSubTab === 'alertas-unificado') ? 'default' : 'ghost'} onClick={() => setActiveControloSubTab('alertas-unificado')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="controlo-subtab-alertas">
                  <ShieldAlert className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Alertas
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Sub-navegacao para Sistema */}
      {activeTab === 'sistema' && (
        <div className="bg-card/30 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex space-x-2 py-3 overflow-x-auto">
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'xd' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('xd')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-xd">
                  <Database className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Integracao XD
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'backups' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('backups')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-backups">
                  <Database className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Backups
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'ips' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('ips')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-ips">
                  <Shield className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Gestao de IPs
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'mapping' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('mapping')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-mapping">
                  <Users className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  XD Mapping
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'lojas' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('lojas')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-lojas">
                  <Shield className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Lojas
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'xd-clientes' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('xd-clientes')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-xd-clientes">
                  <Users className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Importação XD
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'multipreco' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('multipreco')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-multipreco">
                  <TrendingUp className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Multi-Preço & Desvios
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'manutencao' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('manutencao')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-manutencao">
                  <Sparkles className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Manutenção
                </Button>
              )}
              {user.role === 'admin' && (
                <Button variant={activeSistemaSubTab === 'publicar-app' ? 'default' : 'ghost'} onClick={() => setActiveSistemaSubTab('publicar-app')} size="sm" className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2" data-testid="sistema-subtab-publicar-app">
                  <QrCode className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                  Publicar App
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminSubTabs;
